const translation = {
  HOME: 'Accueil',
  ABOUT: 'À propos',
  EXPERIENCE: 'Expérience',
  SERVICES: 'Service',
  PORTFOLIO: 'Portefeuille',
  TESTIMONIALS: 'Témoignage',
  CONTACT: 'PRENDRE CONTACT',
  COPY_RIGHT: 'Fabriqué par Fakhreddine Messaoudi. Tous droits réservés',
};

export default translation;
